import { render, staticRenderFns } from "./OnboardingIdentityStepLayout.vue?vue&type=template&id=9fd074e2"
import script from "./OnboardingIdentityStepLayout.vue?vue&type=script&lang=js"
export * from "./OnboardingIdentityStepLayout.vue?vue&type=script&lang=js"
import style0 from "./OnboardingIdentityStepLayout.vue?vue&type=style&index=0&id=9fd074e2&prod&lang=scss&style=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports